export class StylingArtifact {
  readonly id = 'old/styling/index';
  readonly crate = 'old/styling';
  readonly ns = 'old';
}

export default new StylingArtifact();
